import type { AriaAttributes } from "react";

type MenuItemProps = {
    title: string;
    ariaLabel?: AriaAttributes["aria-label"];
    dataLabel?: string;
    rel?: string;
    target?: string;
    seoTitle?: string;
};
type SubItems = { subItems: Array<MenuItemType> };
type Link = { link: string; isNextLink?: boolean };

export type MenuItemType = MenuItemProps & (SubItems | Link);
type MenuItemTypeWithSubItems = MenuItemProps & SubItems;

export const isMenuItemWithSubItems = (
    item: MenuItemType
): item is MenuItemTypeWithSubItems =>
    Object.prototype.hasOwnProperty.call(item, "subItems");
